import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "../styles/Pro.css";

const Profesionales = () => {
  const [profesionales, setProfesionales] = useState([]);
  const [todos, setTodos] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [filters, setFilters] = useState({ nombre: "", especialidad: "", sucursal: "" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  // Cargar especialidades y todos los profesionales al inicio
  useEffect(() => {
    axios.get("https://vortexcode.cl/api/especialidad").then((res) => setEspecialidades(res.data));
    axios.get("https://vortexcode.cl/api/profesional")
      .then((res) => {
        setTodos(res.data); // Guardar todos los profesionales
        setProfesionales(res.data); // Mostrar todos inicialmente
        setLoading(false);
      })
      .catch(() => setError("Hubo un error al obtener los profesionales"));
  }, []);

  // Manejar cambios en los filtros
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Aplicar filtros
  const aplicarFiltros = () => {
    let filtrados = todos;

    // Filtrar por nombre
    if (filters.nombre) {
      filtrados = filtrados.filter((profesional) =>
        profesional.nombre_profesional.toLowerCase().includes(filters.nombre.toLowerCase()) ||
        profesional.apaterno_profesional.toLowerCase().includes(filters.nombre.toLowerCase())
      );
    }

    // Filtrar por especialidad
    if (filters.especialidad) {
      filtrados = filtrados.filter(
        (profesional) => profesional.especialidad_id_especialidad === parseInt(filters.especialidad)
      );
    }

    // Filtrar por sucursal
    if (filters.sucursal) {
      filtrados = filtrados.filter(
        (profesional) => profesional.sucursal_id_sucursal === parseInt(filters.sucursal)
      );
    }

    setProfesionales(filtrados);
  };

  const destacados = todos.slice(0, 5);

  return (
    <div className="container">
      <div className="busqueda-header">
        <h2>Busqueda de profesionales</h2>
      </div>

      <div className="filtros">
        <input
          type="text"
          name="nombre"
          placeholder="Nombre o apellido del profesional"
          value={filters.nombre}
          onChange={handleInputChange}
        />
        <select name="especialidad" value={filters.especialidad} onChange={handleInputChange}>
          <option value="">Seleccione una Especialidad</option>
          {especialidades.map((esp) => (
            <option key={esp.id_especialidad} value={esp.id_especialidad}>{esp.nombre_especialidad}</option>
          ))}
        </select>
        <select name="sucursal" value={filters.sucursal} onChange={handleInputChange}>
          <option value="">Seleccione una Sucursal</option>
          <option value="1">Av. Nueva Providencia 1881, oficina 1313</option>
          <option value="2">Fidel Oteiza 1971, oficina 302</option>
          <option value="3">Rengo 94, oficina 31</option>
        </select>
        <button onClick={aplicarFiltros}>Buscar</button>
      </div>

      {loading && <p className="text-center">Cargando...</p>}
      {error && <p className="text-danger text-center">{error}</p>}

      {!loading && profesionales.length === 0 && (
        <p className="text-center">Aún no disponible. Disculpe las molestias.</p>
      )}

      {profesionales.length > 0 && (
        <>
          <h3 className="titulo-sub">RESULTADOS DE LA BÚSQUEDA</h3>
          <div className="resultados-listado">
            {profesionales.map((profesional) => (
              <Link
                key={profesional.id_profesional}
                to={`/profesional/${profesional.id_profesional}`}
                className="card-result"
              >
                <img src={profesional.img_profesional} alt={profesional.nombre_profesional} />
                <p className="nombre">{profesional.nombre_profesional} {profesional.apaterno_profesional}</p>
                <p className="especialidad">{profesional.nombre_especialidad}</p>
              </Link>
            ))}
          </div>
        </>
      )}

      <h3 className="titulo-sub">PROFESIONALES DESTACADOS</h3>
      <div className="destacados-carousel">
        <button className="arrow">❮</button>
        <div className="carousel-track">
          {destacados.map((profesional) => (
            <Link
              key={profesional.id_profesional}
              to={`/profesional/${profesional.id_profesional}`}
              className="card-carousel"
            >
              <img src={profesional.img_profesional} alt={profesional.nombre_profesional} />
              <p className="nombre">{profesional.nombre_profesional} {profesional.apaterno_profesional}</p>
              <p className="especialidad">{profesional.nombre_especialidad}</p>
            </Link>
          ))}
        </div>
        <button className="arrow">❯</button>
      </div>
    </div>
  );
};

export default Profesionales;